<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script>
import { getSelectDic } from "@/interfaceAPI/common";
import { otherDic } from '@/assets/json/data'
export default {
    name: "App",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true,
        };
    },
    created() {
        this.isRouterAlive = false;
        getSelectDic().then((res) => {
            const tempDic = {
                ...res.data,
                ...otherDic
            };
            this.$store.commit("user/setDict", tempDic);
            this.isRouterAlive = true;
        });
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
    },
};
</script>

<style lang="scss">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>


// WEBPACK FOOTER //
// src/App.vue